// extracted by mini-css-extract-plugin
module.exports = {"link":"LinksList_link__8FO5l","inverted":"LinksList_inverted__twuCf"};